import { Button } from "../../Button";
import { ConfirmationModal } from "../../ConfirmationModal";
import { deleteMatter, getMattersList } from "../../../api/unit/matters";
import { PropTypes } from "prop-types";
import { QueryLoader } from "../../Loader";
import { Search } from "../../Search";
import { StyledModal } from "../../../styles/StyledModal";
import { StyledTableContainer, StyledTableHeader, StyledTableSearch } from "../../../styles/StyledUnit/StyledContent";
import { UnitMatter } from ".";
import { useQuery } from "react-query";
import { useState } from "react";
import AddIcon from "../../../assets/img/icons/add.svg";
import Modal from "react-modal";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { StyledDecisionTableHeader } from "../../../styles/StyledUnit/StyledDecisionTable";

export default function UnitMatters({ id }) {
	const { axiosPrivate } = useAxiosPrivate();
	const [searchPhrase, setSearchPhrase] = useState(null);
	const { isLoading, isError, error, data, refetch } = useQuery(["mattersTab", id, searchPhrase], () =>
		getMattersList(axiosPrivate, id, searchPhrase)
	);
	const [addNew, setAddNew] = useState(false);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [deletedId, setDeletedId] = useState(null);
	const [editingId, setEditingId] = useState(null);

	const setPhrase = (phrase) => {
		setSearchPhrase(phrase);
		refetch();
	};

	const handleDelete = async (id) => {
		await deleteMatter(axiosPrivate, refetch, id);
	};

	if (!isLoading) {
		if (error) console.log(error);
		if (data.status === 403) {
			return <h6>User not able to preview matters</h6>;
		}
	}

	return (
		<>
			<StyledTableSearch>
				<Search isWhite setPhrase={setPhrase} />
			</StyledTableSearch>
			{!isLoading && !isError ? (
				<>
					<StyledDecisionTableHeader>
						<span>Order</span>
						<span>Matter</span>
						<span>Action</span>
					</StyledDecisionTableHeader>
					<StyledTableContainer>
						{addNew && (
							<UnitMatter
								refetch={refetch}
								setAddNew={setAddNew}
								edit={true}
								data={{}}
								index={data.length}
								total={data.length}
								unitId={parseInt(id)}
								editingId={editingId}
								setEditingId={setEditingId}
							/>
						)}
						{data.map((e, i) => (
							<UnitMatter
								refetch={refetch}
								key={e.id}
								data={e}
								index={i}
								unitId={id}
								total={data.length} 
								openModal={() => setModalIsOpen(true)}
								setDeletedId={setDeletedId}
								editingId={editingId}
  								setEditingId={setEditingId}
							/>
						))}
						{data.length < 1 && <h6>No matters found</h6>}
						<Button icon={AddIcon} onClick={() => setAddNew(true)}>
							Add matter
						</Button>
					</StyledTableContainer>
				</>
			) : (
				<QueryLoader />
			)}
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => {
					setDeletedId(null);
					setModalIsOpen(false);
				}}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ConfirmationModal
					handleDelete={handleDelete}
					deletedId={deletedId}
					closeModal={() => {
						setDeletedId(null);
						setModalIsOpen(false);
					}}
				/>
			</Modal>
		</>
	);
}

UnitMatters.propTypes = {
	id: PropTypes.string,
};
